import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, TitleStrategy, withComponentInputBinding } from '@angular/router';

// Application services and interceptors
import { initializeApp } from './app.initializer';
import { authInterceptor } from './interceptors/auth.interceptor';
import { GlobalConfigurationService } from './services/global-configuration.service';
import { ConfigurationService } from './services/http/clients/configuration.service';
import { AppTitleStrategy } from './utils/strategies/app-title.strategy';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
        // App initialization
        provideAppInitializer(() => {
            const initializerFn = initializeApp(inject(ConfigurationService), inject(GlobalConfigurationService));
            return initializerFn();
        }),

        // Custom title strategy
        {
            provide: TitleStrategy,
            useClass: AppTitleStrategy
        }
    ]
};
